<template>
    <div>
        <a href="javascript:void(0)" class="button p-2" type="button" @click="openMessageModal" :disabled="isDisabled">Send SMS</a>
        <!-- Customer Message Modal -->
        <div class="modal-sm" v-if="showCustomerMessageModal == true">
            <div class="row">
                <div class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group mt-">
                                <label style="font-size: 20px;">Open Message To Customer</label>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-12">
                            <select class="form-control" v-model="selectedTemplate" style="height: 100%;" @change="changeTemplate">
                                <option value="" selected>Select a template</option>
                                <option v-for="template in smsTemplates" :key="template.template_id" :value="template.template_id">
                                    {{ template.template_name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <textarea class="form-control" placeholder="Message" style="resize: none; height: 150px;" v-model="messageContent"></textarea>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-4">
                            <a href="javascript:void(0)" class="button mt-1 p-2" @click="sendSMS(false)"><span> Send Message </span></a>
                        </div>
                        <div class="col-md-4"></div>
                        <div class="col-md-4" style="text-align: right;">
                            <a href="javascript:void(0)" class="button mt-1 p-2" @click="sendSMS(true)"><span> Test Message </span></a>
                        </div>
                    </div>
                </div>
            </div>
            <button type="button" class="icon icon--unlink" v-on:click="showCustomerMessageModal = false">Close</button>
        </div>
        <div class="modal__bg" v-if="showCustomerMessageModal == true"></div>
    </div>
</template>

<script>
export default {
    name: 'TriggerSMS',
    props: {
        bookings: {
            type: Array,
            required: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.fetchSmsTemplates();
    },
    data(){
        return {
            smsTemplates: [],
            showCustomerMessageModal: false,
            selectedTemplate: '',
            messageContent: null
        }
    },
    methods: {
        fetchSmsTemplates() {
            let __this = this;
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}sms/templates`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.$store.dispatch('setLoadStatus')
                if (response.status) {
                   this.smsTemplates = response.data;
                } else {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                
            })
            .catch((error) => {
                this.$store.dispatch('setLoadStatus')
                
            })
        },
        validate() {
            let __this = this
            return new Promise((resolve, reject) => {
                if (!__this.bookings.length > 0) {
                    reject('Please select a booking');
                } 
                if (__this.showCustomerMessageModal && !__this.messageContent) {
                    reject('Please enter a message');
                }

                resolve(true);
            });
        },
        openMessageModal() {
            this.validate().then(() => {
                this.showCustomerMessageModal = true;
            }).catch((error) => {
                this.$notify({
                    type: 'error',
                    title: error
                });
            });
        },
        sendSMS(isTest = false) {
            this.validate().then(() => {
                console.log('isTest', isTest);
                
                this.postMessage(isTest);
            }).catch((error) => {
                this.$notify({
                    type: 'error',
                    title: error
                });
            });
        },
        postMessage(isTest = false) {
            console.log(isTest);
            
            let __this = this;
            let data = {
                bookings: __this.bookings,
                message: __this.messageContent,
                send_as_test: isTest
            };
            this.$store.dispatch('setLoadStatus')
            fetch(`${this.$api}sms/send-message`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.$store.dispatch('setLoadStatus')
                if (response.status) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                    this.messageContent = null;
                    this.showCustomerMessageModal = false;
                } else {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                
            })
            .catch((error) => {
                this.$store.dispatch('setLoadStatus')
                
            })
        },
        changeTemplate() {
            let selected = this.smsTemplates.find(template => template.template_id === this.selectedTemplate);
            if (selected) {
                // Remove HTML tags and decode HTML entities
                this.messageContent = selected.template_body_content
                    .replace(/<[^>]*>/g, '') // Remove HTML tags
                    .replace(/&nbsp;/g, ' ') // Replace non-breaking spaces
                    .replace(/&amp;/g, '&') // Replace encoded ampersands
                    .replace(/&lt;/g, '<') // Replace encoded less than
                    .replace(/&gt;/g, '>') // Replace encoded greater than
                    .replace(/&quot;/g, '"') // Replace encoded quotes
                    .trim(); // Remove leading/trailing whitespace
            } else {
                this.messageContent = null;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>